import { useEffect, useRef } from "react";
import { api, ApiError } from "./api";

export function useSse(
  enabled: boolean,
  initialCursor: number,
  onChange: (recordIds: number[], newCursor: number) => void,
  onAuthError: () => void
): void {
  const cursorRef = useRef(initialCursor);
  const onChangeRef = useRef(onChange);
  const onAuthErrorRef = useRef(onAuthError);

  // Keep callback refs current without resubscribing the EventSource.
  onChangeRef.current = onChange;
  onAuthErrorRef.current = onAuthError;

  useEffect(() => {
    if (!enabled) return;
    const es = new EventSource(`/api/changes/stream?since=${cursorRef.current}`);
    es.addEventListener("change", (ev: MessageEvent) => {
      try {
        const payload = JSON.parse(ev.data);
        cursorRef.current = payload.cursor;
        onChangeRef.current(payload.recordIds, payload.cursor);
      } catch {}
    });
    es.onerror = async () => {
      try {
        await api.me();
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) onAuthErrorRef.current();
      }
    };
    return () => es.close();
  }, [enabled]);
}
